module.exports = __webpack_public_path__ + "static/logo-cvs-health-foundation-white-56e91c56be22532edb4e6d13f0a6172a.svg";